import { Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import Button from '../../components/UI/Button'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { createFee, deleteFee, getConfig, saveConfigImages, updatePortalConfigurations } from '../../services/config'
import BusinessDay from './BusinessDay'
import Features from './Features'
import Fees from './Fees'
import MDORExport from './MDORExport'
import Messaging from './Messaging'
import Notification from './Notification'
import Portal from './Portal'
import POSDrawer from './POSDrawer'
import System from './System'
import { IBingoFee, IConfigParams } from './types'
import { onlyNumbers, returnOnlyNumbersAsInteger } from '../../utils/formValidation'
import { useAuth } from '../../context/AuthProvider/useAuth'

function index(props: { page: string }) {
  const loading = useLoading()
  const { canEdit } = useAuth()
  const [config, setConfig] = useState<IConfigParams>({
    TIMEZONE: "America/New_York",
    START_TIME: "00:00",
    FINISH_TIME: "00:00",
    MDOR_STATE: "",
    ENFORCE_NO_SIMULTANEOUS_REPORT_FOR_USER: "",
    EMAIL_SMTP_SERVER_HOST: "",
    BD_AFTER_WORK_PROCESSING_AFTER_END_MINUTES: "",
    MSG_CASHIER_SYSTEM: "",
    MSG_GAME_SYSTEM_ENABLE: "",
    MSG_BODY_NEW_GAME_SESSION: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_URL: "",
    IMAGE_OF_THE_DAY_FILE: "",
    MSG_ENABLE_NEW_CASHIER_SESSION: "",
    IMAGE_OF_THE_DAY_SHOW_TIME: "",
    POS_SUMMARY_USE_REPORT_SERVER: "",
    DRAWER_AUTOCLOSE_EMAIL_CONTENT: "",
    PORTAL_USE_FLASHBINGO_JAVA: "",
    PORTAL_REPORT_SERVER_DEFAULT: "",
    MSG_BODY_NEW_CASHIER_SESSION: "",
    MSG_HIGHPRIZE_JACKPOT_NEW_SESSION_TIME: "",
    MSG_TERMS_OF_SERVICE: "",
    BD_CLOSE_SESSIONS_AFTER_END_MINUTES: "",
    UPDATE_CONTENT_BEFORE_START_MINUTES: "",
    MDOR_BUSINESS_NAME: "",
    MSG_ENABLE_NEW_GAME_SESSION: "",
    DRAWER_HIGH_CASH_WARNING_ENABLED: "",
    DRAWER_UNREDEEMED_CREDIT_WARNING_ENABLED: "",
    MDOR_CITY: "",
    MSG_HIGHPRIZE_ENABLE: "",
    MDOR_CONTACT_LASTNAME: "",
    ALLOW_CREATE_NEW_DEVICE_ON_PORTAL: "",
    MDOR_PERMIT_ID: "",
    MDOR_EMAIL: "",
    PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME: "",
    BD_NOTIFY_BEFORE_END_MINUTES: "",
    DISTRIBUTOR_REPLICATE_FROM_MANUFACTURER_SQL: "",
    MSG_PRIVACY_POLICY: "",
    MDOR_ADDRESS_LINE_2: "",
    ENABLE_IMAGE_OF_THE_DAY: "",
    REPORT_MONTHLY_REPORT_DISABLE_PULLTABS: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME: "",
    EMAIL_DRAWER_FEATURE_SENDER: "",
    EMAIL_SERVER_USER_LOGIN: "",
    UPDATE_CONTENT_SPREAD_WINDOW_MINUTES: "",
    MDOR_CONTACT_TITLE: "",
    MSG_HIGHPRIZE_BIGWIN_MINVALUE: "",
    PORTAL_USE_DECKGENERATOR_JAVA: "",
    MDOR_CONTACT_FAX: "",
    MDOR_ETIN: "",
    MSG_HIGHPRIZE_JACKPOT_MINVALUE: "",
    MDOR_FEIN: "",
    ACTIVATE_DEVICE_SPREAD_WINDOW_MINUTES: "",
    MDOR_CONTACT_FIRSTNAME: "",
    PORTAL_WELCOME_SCREEN_CHARITY_URL: "",
    MSG_TITLE_NEW_GAME_SESSION: "",
    MDOR_ADDRESS_LINE_1: "",
    MDOR_MFG_ID: "",
    MSG_PRIVACY_POLICY_ENABLE: "",
    ENFORCE_POS_VERSION: "",
    REPORT_TMP_DIRECTORY: "",
    DRAWER_AUTOCLOSE_EMAIL_TITLE: "",
    MIGRATION_USE_REPORT_SERVER: "",
    BINGO_ENABLED: "",
    MSG_GAME_SYSTEM: "",
    SESSION_TIMEOUT_IN_MINUTES: "",
    MSG_CASHIER_SYSTEM_ENABLE: "",
    MSG_TITLE_NEW_CASHIER_SESSION: "",
    DRAWER_HIGH_CASH_WARNING_EMAIL_TITLE: "",
    DRAWER_HIGH_CASH_WARNING_EMAIL_CONTENT: "",
    DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_TITLE: "",
    DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_CONTENT: "",
    MSG_TERMS_OF_SERVICE_ENABLE: "",
    DRAWER_POS_HELP_URL: "",
    MDOR_ENABLED: "",
    MDOR_CONTACT_PHONE: "",
    TOURNAMENT_ENABLED: "",
    MDOR_ZIPCODE: "",
    EMAIL_SERVER_USER_PASSWORD: "",
    MDOR_LICENSE_NUMBER: "",
    ENFORCE_NO_SIMULTANEOUS_CRITICAL_REPORT_FOR_ALL_USERS: "",
    PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_ENABLED: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_ENABLED: "",
    LOBBY_V2_ENABLED:"",
    PT_GAME_TAGS: [],
    DYNAMIC_BUNDLE_DOWNLOAD: "",
    LOCATION_SPECIFIC_LOBBY_ORDER: ""
  })
  const [timeZones, setTimeZones] = useState<string[]>([])
  const [bingoFee, setBingoFee] = useState<IBingoFee[]>([])
  const [image, setImage] = useState<any>()
  const [settingsChanged, setSettingsChanged] = useState<boolean>(false)

  useEffect(() => {
    (async () => {
      loading.addLoading()
      const res = await getConfig()
      if(res.configs?.length > 0) {
        let requestConfigs = {
          ...config
        }
        res.configs.forEach((resConfig) => {
          let {value} = resConfig
          if(!value) return 
          if(resConfig.key === 'MSG_HIGHPRIZE_JACKPOT_MINVALUE' || resConfig.key === 'MSG_HIGHPRIZE_BIGWIN_MINVALUE') value = `${parseInt(value)}`
          requestConfigs = {
            ...requestConfigs,
            [resConfig.key as keyof typeof config]: value
          }
        })
        setConfig(requestConfigs)
      }
      if(res.timezones?.length > 0) setTimeZones(res.timezones)
      if(res.bingo_fee?.length > 0) setBingoFee(res.bingo_fee)
      loading.removeLoading()
    })()
  }, [])

  const changeConfigSettings = (e: string, field: string) => {
    setSettingsChanged(true)
    setConfig({
      ...config,
      [field] : e
    })
  }

  const addOrDeleteFee = async (id?: string, fee?: {valid_at: string, value: number;}) => {
    loading.addLoading()
    if(fee) await createFee(fee)
    if(id) await deleteFee({id})
    const res = await getConfig()
    if(!!res.bingo_fee) setBingoFee(res.bingo_fee)
    loading.removeLoading()
  }

  const updateConfigs = async () => {
    let formData = new FormData()
    formData.append('files', image)
    const configParsed = {
      ...config,
      'MSG_HIGHPRIZE_JACKPOT_MINVALUE': returnOnlyNumbersAsInteger(config.MSG_HIGHPRIZE_JACKPOT_MINVALUE),
      'MSG_HIGHPRIZE_BIGWIN_MINVALUE': returnOnlyNumbersAsInteger(config.MSG_HIGHPRIZE_BIGWIN_MINVALUE),
    }

    const configsAsArray = Object.keys(configParsed).map((key) => {
      return {key, value: configParsed[key as keyof typeof configParsed]}
    })

    const filtered = configsAsArray.filter((config: any) => !config.key.includes('PT_GAME_TAGS') && !config.key.includes('LOBBY_TABS'))

    let res : boolean = true
    if(image) {
      res = await saveConfigImages(image)
    }
    if(res) {
      await updatePortalConfigurations(filtered)
    }
    setSettingsChanged(false)
  }

  const setPreviewImage = (file: any) => {
    if(file) setImage(file)
  }

  const pageProps = {
    config,
    setConfig: changeConfigSettings,
    feeList: bingoFee,
    addOrDeleteFee,
    timeZones,
    image,
    setPreviewImage,
    updateConfigs
  }

  return (
    <>
      <div className="config-container">
        {getCurrentPage(props.page, pageProps)}
      </div>
      <Divider />
      {props.page !== 'fees' ? (
        <div className="config__save">
          <Button disabled={!canEdit || !settingsChanged}
                  type="primary"
                  onClick={updateConfigs}>
            <p>Save</p>
          </Button>
        </div>
      ):(
        <></>
      )}

    </>
  )
}

export default index

const getCurrentPage = (current: string, pageProps: any) => {

  const {
    config,
    setConfig,
    feeList,
    addOrDeleteFee,
    timeZones,
    setPreviewImage,
    updateConfigs
  } = pageProps;

  if(current === 'business_day') return <BusinessDay timeZones={timeZones} config={config} setConfig={setConfig} />
  if(current === 'features') return <Features config={config} setConfig={setConfig} />
  if(current === 'fees') return <Fees feeList={feeList} addOrDeleteFee={addOrDeleteFee}/>
  if(current === 'mdorExport') return <MDORExport config={config} setConfig={setConfig} />
  if(current === 'messaging') return <Messaging config={config} setConfig={setConfig} setImage={setPreviewImage}/>
  if(current === 'notification') return <Notification config={config} setConfig={setConfig} />
  if(current === 'system') return <System config={config} setConfig={setConfig} />
  if(current === 'portal') return <Portal config={config} setConfig={setConfig} saveConfigs={updateConfigs}/>
  if(current === 'posDrawer') return <POSDrawer config={config} setConfig={setConfig} />
  return <BusinessDay timeZones={timeZones} config={config} setConfig={setConfig} />
}
